import { render, staticRenderFns } from "./OverviewTree.vue?vue&type=template&id=60c9b766&"
import script from "./OverviewTree.vue?vue&type=script&lang=js&"
export * from "./OverviewTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports